import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class PersonErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/CustomerProfile\/Person/,
      messages: {
        400: 'errors.personDetailsFailed',
        404: 'errors.personDetailsFailed',
        500: 'errors.personDetailsFailed',
        success: {
          default: 'errors.personDetailsFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/Users\/AcceptTermsAndConditions/,
      messages: {
        400: 'errors.acceptTermsAndConditionsFailed',
        404: 'errors.acceptTermsAndConditionsFailed',
        500: 'errors.acceptTermsAndConditionsFailed',
        success: {
          default: 'errors.acceptTermsAndConditionsFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/Users\/GivePrivacyConsent/,
      messages: {
        400: 'errors.givePrivacyConsentFailed',
        404: 'errors.givePrivacyConsentFailed',
        500: 'errors.givePrivacyConsentFailed',
        success: {
          default: 'errors.givePrivacyConsentFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/Users\/RevokeTermsAndConditions/,
      messages: {
        400: 'errors.revokeTermsAndConditionsFailed',
        404: 'errors.revokeTermsAndConditionsFailed',
        500: 'errors.revokeTermsAndConditionsFailed',
        success: {
          default: 'errors.revokeTermsAndConditionsFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/Users\/RevokePrivacyConsent/,
      messages: {
        400: 'errors.revokePrivacyConsentFailed',
        404: 'errors.revokePrivacyConsentFailed',
        500: 'errors.revokePrivacyConsentFailed',
        success: {
          default: 'errors.revokePrivacyConsentFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
